/*
 * @Description: 首页
 * @Author: gao shuai
 * @Date: 2020-05-05 10:41:24
 * @LastEditTime: 2020-07-11 10:25:59
 * @LastEditors: gao shuai
 */

import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  // 获取最新登录记录
  async loginLog(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetLastLoginLog',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 获取订单商户信息
  async merchantInfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetIndexOrderUsers',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 获取首页订单金额统计信息
  async MoneyInfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetIndexOrder',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 获取首页订单金额统计信息
  async TodayOrderCount(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/TodayOrderCount',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  async YesterdayOrderCount(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/YesterdayOrderCount',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  async TodayPayAmount(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/TodayPayAmount',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  async YesterdayPayAmount(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/YesterdayPayAmount',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 日时间段交易统计
  async chart1(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetHourOrderProfit',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 近十五日交易记录
  async chart2(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetNearly15DaysOrderProfit',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 产品日交易统计
  async chart4(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetProductTodayOrder',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 商户日交易统计
  async chart3(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetMerchantTodayAmount',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 修改密码
  async repassword(params) {
    let header = await mgr();
    return api({
      url: '/api/UserManage/ResetPassword',
      method: 'post',
      data: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 退出时请求
  async loginOut(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/LoginOut',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 上传图像的图片
  async uploadprofit(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/UploadImage',
      method: 'post',
      data: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 获取用户图像
  async getProfile(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetHeadImgAsync',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 二级密码的修改
  async sconedPassword(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/SetSecondaryPasswordAsync',
      method: 'post',
      data: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 二级密码的修改
  async limitTime(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetLaterTimeAsync',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  }
};
